import { render } from "./InquiryConfirmation.vue?vue&type=template&id=ace60220&scoped=true"
import script from "./InquiryConfirmation.vue?vue&type=script&lang=js"
export * from "./InquiryConfirmation.vue?vue&type=script&lang=js"

import "./InquiryConfirmation.vue?vue&type=style&index=0&id=ace60220&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace60220"]])

export default __exports__